import React, { useEffect, useState } from "react";
import { invoiceDate, electricityDate } from '../Utils/function';

function Invoice(props) {
    const [idata, setData] = useState(props.data);
    const [isPrintButton, setPrintButton] = useState(true);

    useEffect(() => {
        if (props.data !== idata) {
            setData(props.data);
        }
    }, [props.data]);

    const getBillerRef = () => {
        if (!idata?.responseData) return 'N/A';
        try {
            const data = typeof idata.responseData === 'string'
                ? JSON.parse(idata.responseData)
                : idata.responseData;
            return (data?.field1 && data.field1.toString().trim() !== '') ? data.field1 : 'N/A';
        } catch {
            return 'N/A';
        }
    };

    const invoiceData = {
        customerName: idata?.name || 'N/A',
        customerPhoneNumber: idata?.mobile || idata?.mobileUnitCycle || '',
        accountNumber: idata?.accountNumber || 'N/A',
        category: props?.category || 'N/A',
        orderNumber: idata?.transactionId || 'N/A',
        billerReference: getBillerRef(),
        provider: idata?.electricityproviders?.name || idata?.provider || 'N/A',
        billedAmount: parseFloat(idata?.billAmount || 0),
        paidAmount: parseFloat(idata?.billAmount || 0),
        dueDate: idata?.billDueDate || 'N/A',
        billDate: idata?.createdAt ? electricityDate(idata.createdAt) : 'N/A',
        txnStatus: idata?.status === 3 ? 'PAYMENT_SUCCESS' :
                   idata?.status === 2 ? 'PAYMENT_PENDING' : 'PAYMENT_FAILURE'
    };

    const displayStatus = invoiceData.txnStatus ? (
        <span className={invoiceData.txnStatus === 'PAYMENT_SUCCESS' ? 'text-success fw-bold' : 
                        invoiceData.txnStatus === 'PAYMENT_PENDING' ? 'text-warning fw-bold' : 'text-danger fw-bold'}>
            {invoiceData.txnStatus.replace(/_/g, ' ')}
        </span>
    ) : <span className="text-muted">Unknown</span>;

    const handlePrint = () => {
        const transactionId = idata?.transactionId || 'Receipt';
        const printWindow = window.open('', '_blank');

        if (!printWindow) {
            alert("Please allow pop-ups for printing.");
            return;
        }

        const content = document.querySelector('.bbps-invoice-wrapper').outerHTML;

        printWindow.document.write(`
            <!DOCTYPE html>
            <html>
            <head>
                <title>${transactionId}</title>
                <style>
                    @page { size: A4 portrait; margin: 6mm; }
                    body { margin:0; padding:10px; font-family: Arial, sans-serif; font-size: 12px; line-height: 1.35; }
                    .bbps-invoice-wrapper { max-width: 720px; margin: 0 auto; padding: 12px 15px; }
                    .bbps-header-row { display: flex; align-items: center; justify-content: space-between; border-bottom: 2px solid #C9262C; padding-bottom: 8px; margin-bottom: 12px; }
                    .bbps-header-row img { height: 42px; }
                    .bbps-header-row h3 { margin: 0; color: #C9262C; font-size: 18px; }
                    .bbps-info-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; margin-bottom: 12px; }
                    .bbps-info-card { border: 1px solid #ddd; border-radius: 5px; padding: 8px; }
                    .bbps-info-row { display: flex; justify-content: space-between; margin: 5px 0; }
                    .bbps-info-label { font-weight: 600; }
                    table { width: 100%; border-collapse: collapse; margin: 10px 0; }
                    th, td { border: 1px solid #ccc; padding: 6px 5px; text-align: left; }
                    th { background: #f5f5f5; }
                    .amount { font-weight: bold; color: #C9262C; }
                    .footer { margin-top: 15px; text-align: center; font-size: 11px; }
                </style>
            </head>
            <body>
                ${content}
            </body>
            </html>
        `);

        printWindow.document.close();
        setTimeout(() => {
            printWindow.focus();
            printWindow.print();
        }, 500);
    };

    if (!idata) return <div>Loading invoice...</div>;

    return (
        <div className="bbps-invoice-wrapper">
            <style>{`
                .bbps-invoice-wrapper {
                    padding: 25px;
                    background: white;
                    font-family: Arial, sans-serif;
                    max-width: 800px;
                    margin: 0 auto;
                }
                .bbps-header-row {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    border-bottom: 3px solid #C9262C;
                    padding-bottom: 15px;
                    margin-bottom: 20px;
                }
                .bbps-header-row img { height: 55px; }
                .bbps-header-row h3 { margin: 0; color: #C9262C; font-size: 22px; }

                .bbps-info-grid {
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);
                    gap: 18px;
                    margin-bottom: 20px;
                }
                .bbps-info-card {
                    border: 1px solid #e0e0e0;
                    border-radius: 8px;
                    padding: 14px;
                }
                .bbps-info-row {
                    display: flex;
                    justify-content: space-between;
                    margin: 8px 0;
                }
                .bbps-info-label { font-weight: 600; color: #555; }

                table {
                    width: 100%;
                    border-collapse: collapse;
                    margin: 15px 0;
                }
                th, td {
                    border: 1px solid #ddd;
                    padding: 10px;
                    text-align: left;
                }
                th { background: #f5f5f5; }
                .amount { font-weight: bold; color: #C9262C; }

                .footer {
                    margin-top: 25px;
                    text-align: center;
                    font-size: 12px;
                    color: #666;
                }
                .bbps-print-btn {
                    background: #C9262C;
                    color: white;
                    border: none;
                    border-radius: 40px;
                    padding: 10px 28px;
                    cursor: pointer;
                    margin-top: 15px;
                }
            `}</style>

            {/* Header - Logo and Title in same row */}
            <div className="bbps-header-row">
                <img src="../logo.png" alt="Bharat BillPay" />
                <h3>Payment Receipt</h3>
            </div>

            {/* <p style={{ textAlign: 'center', margin: '8px 0 20px 0', fontSize: '13.5px' }}>
                Generated on {invoiceDate(new Date())}
            </p> */}

            <div className="bbps-info-grid">
                <div className="bbps-info-card">
                    <div className="bbps-info-row"><span className="bbps-info-label">Customer Name:</span><span>{invoiceData.customerName}</span></div>
                    <div className="bbps-info-row"><span className="bbps-info-label">Mobile Number:</span><span>{invoiceData.customerPhoneNumber}</span></div>
                    <div className="bbps-info-row"><span className="bbps-info-label">Account Number:</span><span>{invoiceData.accountNumber}</span></div>
                    <div className="bbps-info-row"><span className="bbps-info-label">Category:</span><span>{invoiceData.category}</span></div>
                </div>
                <div className="bbps-info-card">
                    <div className="bbps-info-row"><span className="bbps-info-label">Order Number:</span><span>{invoiceData.orderNumber}</span></div>
                    <div className="bbps-info-row"><span className="bbps-info-label">Biller Reference:</span><span>{invoiceData.billerReference}</span></div>
                    <div className="bbps-info-row"><span className="bbps-info-label">Provider:</span><span>{invoiceData.provider}</span></div>
                </div>
            </div>

            <table>
                <thead>
                    <tr><th>Description</th><th>Details</th></tr>
                </thead>
                <tbody>
                    <tr><td>Billed Amount</td><td className="amount">₹{invoiceData.billedAmount.toFixed(2)}</td></tr>
                    <tr><td>Amount Paid</td><td className="amount">₹{invoiceData.paidAmount.toFixed(2)}</td></tr>
                    <tr><td>Due Date</td><td>{invoiceData.dueDate}</td></tr>
                    <tr><td>Bill Date</td><td>{invoiceData.billDate}</td></tr>
                    <tr><td>Status</td><td>{displayStatus}</td></tr>
                </tbody>
            </table>

            <div className="footer">
                {isPrintButton && (
                    <button onClick={handlePrint} className="bbps-print-btn">
                        <i className="mr-1 fa fa-print" /> Print Receipt
                    </button>
                )}
            </div>
        </div>
    );
}

export default Invoice;